<!-- Sección de Carga Simulada -->
<div *ngIf="isLoadingProcess" class="loading-process-container">

  <div class="loading-content">
    <div class="spinner-with-icon">
      <div class="loader" aria-hidden="true"></div>
      <icon-cargando-tramite></icon-cargando-tramite>
    </div>
    <h1 class="loading-title">Listo, estamos procesando la solicitud de tramite de pensión.</h1>
    <p class="loading-subtitle">Este proceso puede tardar un momento.</p>
    <p class="loading-message">{{ currentMessage }}</p>
  </div>
</div>

<div class="container-confirmar-datos-pension" *ngIf="!isLoadingProcess">
  <!-- Contenido Principal -->
  <div>
    <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>

    <h1 class="title-section title">Solicitud de Pensión por Vejez</h1>

    <div class="item-text">
      <p id="tramite" class="sub-title">
        Confirma tu información</p>
      <ion-text class="div-text ftw-400 mt8">
        Por favor, revisa con atención todos los datos. Si algo está incorrecto o desactualizado, comunícate con
        nosotros
        y te ayudaremos
      </ion-text>

      <h2 class="sub-title mt24">Datos personales</h2>
      <!-- Datos personales 1 -->
      <div id="datosPersonales" class="div-personal-data">
        <div class="div-data">
          <ion-text class="descripcion">Nombre:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.name">
              {{ personalData?.name || "Aún no registras tu nombre" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Apellido:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.lastName">
              {{ personalData?.lastName || "Aún no registras tu apellido" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Rut:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.rut">
              {{ personalData?.rut || "Aún no registras tu rut" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Sexo:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.gender">
              {{ personalData?.gender || "Aún no registras tu sexo" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Fecha de nacimiento:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.birthDate">
              {{
              personalData?.birthDate ||
              "Aún no registras tu fecha de nacimiento"
              }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Estado civil:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.civilStatus">
              {{
              personalData?.civilStatus || "Aún no registras tu estado civil"
              }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Institución de salud:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.institucionSalud">
              {{
              personalData?.institucionSalud || "Aún no registras tu institución de salud"
              }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
      </div>


      <!-- Datos personales 2 -->
      <h2 class="sub-title mt24">Datos de contacto</h2>
      <div class="div-personal-data">
        <div class="div-data">
          <ion-text class="descripcion">Domicilio:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.direccionCompleta">
              {{ personalData?.direccionCompleta || "Aún no registras tu domicilio" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Teléfono:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.phoneNumber">
              {{
              personalData?.phoneNumber
              ? "+569" + personalData.phoneNumber
              : "Aún no registras tu teléfono"
              }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <div class="div-data">
          <ion-text class="descripcion">Correo:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!personalData?.email">
              {{ personalData?.email || "Aún no registras tu correo" }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
      </div>

      <!-- Beneficiarios-->
      <h2 class="sub-title mt24">Tus Beneficiarios</h2>
      <div class="balances-table-wrapper">
        <table class="balances-table balances-table--cols-3 tbl-beneficiarios">
          <thead>
            <tr class="balances-table__head">
              <th
                *ngFor="let header of headerBeneficiaries; let i = index"
                [ngClass]="'balances-table__col-' + (i + 1)">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="balances-table__row" *ngFor="let beneficiary of beneficiaries">
              <td class="balances-table__col-1 td-overflow">
                <strong>{{ beneficiary.nombre }}</strong>
              </td>
              <td class="balances-table__col-2">{{ beneficiary.parentesco }}</td>
              <td class="balances-table__col-3 td-rut">{{ beneficiary.rut }}</td>
            </tr>
          </tbody>
        </table>
        <ion-text class="beneficiarios-empty-message" *ngIf="!beneficiaries?.length">
          {{ "Aún no registras tus Beneficiarios" }}
        </ion-text>
      </div>
      <div class="mensaje-scroll-mobile">
        <icon-swipe-right></icon-swipe-right>
        Desliza hacia la derecha para revisar todo el contenido
      </div>

      <h2 class="sub-title mt24">Saldos obligatorios</h2>
      <ng-container
        *ngTemplateOutlet="balancesTableTemplate; context: { balances: balances }">
      </ng-container>

      <!-- Bonos-->
      <div *ngIf="bonos && bonos.length > 0">
        <h2 class="sub-title mt24">Bonos</h2>
        <div class="balances-table-wrapper">
          <table class="balances-table balances-table--cols-4">
            <caption class="sr-only">Tabla de bonos de reconocimiento</caption>
            <thead>
              <tr class="balances-table__head">
                <th class="balances-table__col-1">Nombre</th>
                <th class="balances-table__col-2">Estado</th>
                <th class="balances-table__col-3">Fecha actualización</th>
                <th class="balances-table__col-4">Saldo Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="balances-table__row" *ngFor="let bono of bonos">
                <td class="balances-table__col-1">{{ bono.bondTypeDescription }}</td>
                <td class="balances-table__col-2">{{ bono.bondStatus }}</td>
                <td class="balances-table__col-3 balances-table__cell--num">
                  {{ bono.expirationDate }}
                </td>
                <td class="balances-table__col-4 balances-table__cell--num">
                  ${{ bono.currentValue }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mensaje-scroll-mobile">
          <icon-swipe-right></icon-swipe-right>
          Desliza hacia la derecha para revisar todo el contenido
        </div>
      </div>

      <h2 class="sub-title mt-12 mb-20">Antecedentes de pensión</h2>
      <div *ngFor="let item of listaPreguntasAntecedentesPension" class="lista-check">
        <ion-item lines="none">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">{{ item.descripcion }}</ion-text>
        </ion-item>
      </div>

      <ng-container *ngIf="balancesVoluntario.length">
        <h2 class="sub-title mt24">Saldos voluntarios</h2>
        <ng-container
          *ngTemplateOutlet="balancesTableTemplate; context: { balances: balancesVoluntario }">
        </ng-container>
      </ng-container>

      <ng-template #balancesTableTemplate let-balances="balances">
        <div class="balances-table-wrapper" *ngIf="balances?.length">
          <table class="balances-table balances-table--cols-4">
            <caption class="sr-only">
              Tabla de saldos por tipo de cuenta y fondo
            </caption>
            <thead>
              <tr class="balances-table__head">
                <th
                  *ngFor="let header of headerBalances; let i = index"
                  [ngClass]="'balances-table__col-' + (i + 1)">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let balance of balances">
                <tr class="balances-table__row" *ngFor="let row of balance.rows; let rowIndex = index">
                  <td
                    *ngIf="rowIndex === 0"
                    class="balances-table__col-1 balances-table__cell--tipo"
                    [attr.rowspan]="balance.rows.length">
                    {{ balance.accountType }}
                  </td>
                  <td class="balances-table__col-2">{{ row.fund }}</td>
                  <td class="balances-table__col-3 balances-table__cell--num">
                    {{ row.balanceInstallments }}
                  </td>
                  <td class="balances-table__col-4 balances-table__cell--num">
                    ${{ row.balancePesos }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="mensaje-scroll-mobile">
          <icon-swipe-right></icon-swipe-right>
          Desliza hacia la derecha para revisar todo el contenido
        </div>
        <p class="balances-disclaimer">
          (*)Los montos son referenciales y podrían variar según la variación del valor cuota
        </p>
      </ng-template>

      <h2 class="sub-title mt-12">Vía de pago</h2>
      <div class="div-personal-data">
        <div class="div-data">
          <ion-text class="descripcion">Vía de pago:</ion-text>
          <ng-container *ngIf="!loadingPersonalData">
            <ion-text class="value" [class.sinRegistro]="!tiposCuentas?.descripcionViaPago">
              {{ tiposCuentas?.descripcionViaPago }}
            </ion-text>
          </ng-container>
          <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
        </div>
        <ng-container *ngIf="tiposCuentas?.numeroCuenta">
          <div class="div-data">
            <ion-text class="descripcion">Banco:</ion-text>
            <ng-container *ngIf="!loadingPersonalData">
              <ion-text class="value" [class.sinRegistro]="!tiposCuentas?.descripcionBanco">
                {{ limpiarBanco(tiposCuentas?.descripcionBanco) }}
              </ion-text>
            </ng-container>
            <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
          </div>
          <div class="div-data">
            <ion-text class="descripcion">N° de cuenta:</ion-text>
            <ng-container *ngIf="!loadingPersonalData">
              <ion-text class="value" [class.sinRegistro]="!tiposCuentas.numeroCuenta">
                {{ tiposCuentas.numeroCuenta }}
              </ion-text>
            </ng-container>
            <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
          </div>
          <div class="div-data">
            <ion-text class="descripcion">Tipo de cuenta:</ion-text>
            <ng-container *ngIf="!loadingPersonalData">
              <ion-text class="value" [class.sinRegistro]="!tiposCuentas.descripcionTipoCuenta">
                {{ tiposCuentas.descripcionTipoCuenta}}
              </ion-text>
            </ng-container>
            <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
          </div>
        </ng-container>
      </div>

      <h2 class="sub-title mt24 mb-10">Documentación</h2>

      <div class="lista-check">
        <ion-item lines="none" *ngIf="status.nacimiento === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado Nacimiento</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status['nacimiento-conyuge'] === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Nacimiento cónyuge</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status.matrimonio == 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Matrimonio</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status['union-civil'] === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Unión Civil</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status['nacimiento-beneficiario-1'] === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Nacimiento Beneficiario 1</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status['nacimiento-beneficiario-2'] === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Nacimiento Beneficiario 2</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="status['nacimiento-beneficiario-3'] === 'SUCCESS'">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <ion-text class="descripcion">Certificado de Nacimiento Beneficiario 3</ion-text>
        </ion-item>
      </div>

      <div class="confirmacion mt24">
        <h2 class="sub-title">Para continuar, por favor confirma lo siguiente:</h2>
        <form [formGroup]="form">
          <div class="info-check mt24">
            <div class="info-check__check">
              <ion-checkbox slot="start" formControlName="checkData" (ionChange)="formValueChange()"
                (keydown)="onCheckboxKeydown($event)">
              </ion-checkbox>
            </div>
            <ion-label class="label-check">
              Leí con atención mis datos personales y confirmo que son correctos. Entiendo que, si algún dato es
              erróneo,
              mi trámite podría tener demoras.
            </ion-label>
          </div>
        </form>
      </div>
      <div class="div-btn-continuar mt24">
        <button class="primary-button" [disabled]="btnDisabled" (click)="continue()">
          Continuar
        </button>
      </div>
    </div>
  </div>
</div>